import React, {useId} from 'react';
import {Controller, useFormContext} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import {InfoOutline} from '@vedmarket/ui-kit';

import {COLORS, DECLARATION_FORM} from 'config/constants';
import {useCalculationReadOnly} from 'components/cabinet/calculator/calculation-read-only';
import {formatReferenceCopy as formatDemoCopy} from 'utils/typography';

const PreferencesSelect = ({handleChangePreferences}: CustomsPreferencesControlProps) => {
  const {t} = useTranslation();

  const {control} = useFormContext<DeclarationFormFields>();
  const labelId = useId();
  const readOnly = useCalculationReadOnly();
  const label = t('calc__text__customs__certificateOfOrigin');

  return (
    <FormControl fullWidth disabled={readOnly} className='preferences-control'>
      <InputLabel id={labelId} shrink>
        <Typography component='span' variant='inherit'>{formatDemoCopy(label)}</Typography>
      </InputLabel>
      <Controller
        name={DECLARATION_FORM.HAS_PREFERENCES}
        control={control}
        render={({field}) => (
          <Select
            {...field}
            value={field.value || 'false'}
            labelId={labelId}
            label={label}
            notched
            onChange={(event) => {
              field.onChange(event.target.value);
              handleChangePreferences(event.target.value === 'true');
            }}
            sx={{backgroundColor: COLORS.WHITE}}
            renderValue={(selected) => (
              <Typography component='span' variant='body1' sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                color: COLORS.BLACK_DARK,
                letterSpacing: 0,
              }}>
                <InfoOutline style={{
                  color: COLORS.LIGHT_ACTION,
                  flexShrink: 0,
                }} />
                {formatDemoCopy(selected === 'true' ? t('calc__text__customs__confirmPreferences') : t('calc__text__customs__refusePreferences'))}
              </Typography>
            )}
          >
            <MenuItem value='true'>
              <Typography variant='inherit'>{formatDemoCopy(t('calc__text__customs__confirmPreferences'))}</Typography>
            </MenuItem>
            <MenuItem value='false'>
              <Typography variant='inherit'>{formatDemoCopy(t('calc__text__customs__refusePreferences'))}</Typography>
            </MenuItem>
          </Select>
        )}
      />
    </FormControl>
  );
};

export default PreferencesSelect;
